export default "__VITE_ASSET__uRFkXoLx__"